// // audio icon
import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Box, Typography, Button } from "@mui/material";
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import LoadingIndicator from "../components/LoadingIndicator";
import { useLanguage } from "../../../services/localization/LanguageContex";
import Tooltip from '@mui/material/Tooltip';

function SignsSubScreenTwo() {
  const { language, t } = useLanguage();
  const { sign, category } = useParams();
  const navigate = useNavigate();
  const categoryItemList = useSelector((state) => state.sign.signs);

  const [currentIndex, setCurrentIndex] = useState(-1);
  const [signData, setSignData] = useState(null);
  const [isPlaying, setIsPlaying] = useState(true);
  const [isEnded, setIsEnded] = useState(false);

  const audioRef = useRef(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!categoryItemList || categoryItemList.length === 0) {
      navigate(`/home/signsCategory/${encodeURIComponent(category)}`);
      return;
    }

    const index = categoryItemList.findIndex(
      (item) => item.enTitle === decodeURIComponent(sign)
    );
    if (index !== -1) {
      setCurrentIndex(index);
      setSignData(categoryItemList[index]);
      setIsPlaying(true);
      setIsEnded(false);
    }

    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.currentTime = 0;
      }
    };
  }, [sign, category, categoryItemList, navigate]);

  useEffect(() => {
    if (audioRef.current && signData?.audioUrl) {
      audioRef.current.play().catch(() => setIsPlaying(false));
      setIsEnded(false);
    }
  }, [signData]);

  useEffect(() => {
    if (!audioRef.current) return;

    const handleEnded = () => {
      setIsEnded(true);
      // Keep icon as playing icon by not changing isPlaying here
    };

    const audioEl = audioRef.current;
    audioEl.addEventListener("ended", handleEnded);

    return () => {
      audioEl.removeEventListener("ended", handleEnded);
    };
  }, [audioRef]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.hidden && audioRef.current) {
        audioRef.current.pause();
        setIsPlaying(false);
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  // const togglePlay = () => {
  //   // if (!audioRef.current) return;

  //   if (audioRef.current.paused || isEnded) {
  //     // Replay from start if ended or paused
  //     audioRef.current.currentTime = 0;
  //     audioRef.current.play();
  //     setIsPlaying(true);
  //     setIsEnded(false);
  //   } else {
  //     // Pause if playing
  //     audioRef.current.pause();
  //     setIsPlaying(false);
  //   }
  // };
  const togglePlay = async () => {
  if (!audioRef.current) return;

  audioRef.current.currentTime = 0;  // Reset to start
    try {
    await audioRef.current.play();
    setIsPlaying(true);
    setIsEnded(false);
  } catch (err) {
    console.error("Audio playback failed:", err);
  }
  // audioRef.current.play();
  // setIsPlaying(true);
  // setIsEnded(false);
};


  if (!signData) return <LoadingIndicator />;

  return (
    <Box sx={{ px: { xs: 1, sm: 6, md: 6 }, pt: 2, pb: 4 }}>
      <Typography
        variant="h4"
        gutterBottom
        align="center"
        sx={{ fontSize: { xs: "1.5rem", sm: "1.7rem", md: "2rem" } }}
      >
        {/* {language === "en"
          ? signData.enTitle.charAt(0).toUpperCase() + signData.enTitle.slice(1)
          : signData.dzTitle
          ? signData.dzTitle
          : t(signData.enTitle) !== signData.enTitle
          ? t(signData.enTitle)
          : signData.enTitle.charAt(0).toUpperCase() + signData.enTitle.slice(1)} */}

          {language === "en"
          ? signData.enTitle
          : signData.dzTitle
          ? signData.dzTitle
          : t(signData.enTitle)}
      </Typography>

      <Box sx={{ flexDirection: "column" }}>
<>
        <Box
          component="img"
          key={currentIndex}
          src={signData.webpUrl}
          alt={signData.enTitle}
          sx={{
            width: "100%",
            height: { xs: 200, sm: 400, md: 500 },
            mb: 0,
            overflow: "hidden",
            position: "relative",
            objectFit: "contain",
          }}
        />
        {/* Navigation buttons */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 2,
            // mt: 1,
          }}
        >
          <Button
            onClick={() =>
              navigate(
                `/home/signsCategory/${encodeURIComponent(category)}/${encodeURIComponent(
                  categoryItemList[currentIndex - 1].enTitle
                )}`
              )
            }
            disabled={currentIndex <= 0}
            startIcon={<ArrowBackIosIcon />}
            variant="outlined"
          />
         {/* Hidden audio player */}
        <audio
          ref={audioRef}
          src={signData.audioUrl}
          autoPlay
          style={{ display: "none" }}
        />
           {/* Play toggle button with replay on ended */}
               {/* Replay button */}
                        <Tooltip title={t("Play audio")}>
                       <Button
                         onClick={togglePlay}
                         sx={{
                           display: "flex",
                           justifyContent: "center",
                           alignItems: "center",
                           mx: "auto",
                           borderRadius: 5,
                           width: { xs: 20, sm: 20, md: 25 },
                         }}
                       >
                         <VolumeUpIcon
                           sx={{
                             color: "rgba(27,39,58,1)",
                             width: { xs: 20, sm: 20, md: 25 },
                           }}
                         />
                       </Button>
                       </Tooltip>
        {/* <Button
          onClick={togglePlay}
          // sx={{
          //   display: "flex",
          //   justifyContent: "center",
          //   alignItems: "center",
          //   mx: "auto",
          //   mt: 1,
          // }}
        >
          <VolumeUpIcon sx={{ color: "rgba(27,39,58,1)" }} />
        </Button> */}

          <Button
            onClick={() =>
              navigate(
                `/home/signsCategory/${encodeURIComponent(category)}/${encodeURIComponent(
                  categoryItemList[currentIndex + 1].enTitle
                )}`
              )
            }
            disabled={currentIndex >= categoryItemList.length - 1}
            endIcon={<ArrowForwardIosIcon />}
            variant="outlined"
            // sx={{ color: "rgba(27,39,58,1)", 
            //   borderColor :"rgba(27,39,58,1)",
            // }}
          />
        </Box>
</>
      </Box>
    </Box>
  );
}

export default SignsSubScreenTwo;





// // no audio icon
// import React, { useEffect, useState, useRef } from "react";
// import { useParams, useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import { Box, Typography, Button } from "@mui/material";
// import VolumeDownIcon from '@mui/icons-material/VolumeDown';
// import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
// import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
// import LoadingIndicator from "../components/LoadingIndicator";
// import { useLanguage } from "../../../services/localization/LanguageContex";

// function SignsSubScreenTwo() {
//   const { language, t } = useLanguage();
//   const { sign, category } = useParams();
//   const navigate = useNavigate();
//   const categoryItemList = useSelector((state) => state.sign.signs);

//   const [currentIndex, setCurrentIndex] = useState(-1);
//   const [signData, setSignData] = useState(null);
  
//   const audioRef = useRef(null);

//   useEffect(() => {
//     // window.scrollTo(0, 0);
//     if (!categoryItemList || categoryItemList.length === 0) {
//       navigate(`/home/signsCategory/${encodeURIComponent(category)}`);
//       return;
//     }

//     const index = categoryItemList.findIndex(
//       (item) => item.enTitle === decodeURIComponent(sign)
//     );
//     if (index !== -1) {
//       setCurrentIndex(index);
//       setSignData(categoryItemList[index]);
//     }

//     return () => {
//       if (audioRef.current) {
//         audioRef.current.pause();
//         audioRef.current.currentTime = 0;
//       }
//     };
//   }, [sign, category, categoryItemList, navigate]);

//   // Load image dimensions when signData.webpUrl changes
//   useEffect(() => {
//     if (!signData || !signData.webpUrl) {
//       return;
//     }
//   }, [signData]);

//   // Optional: Pause audio when user switches tabs
//   useEffect(() => {
//     const handleVisibilityChange = () => {
//       if (document.hidden && audioRef.current) {
//         audioRef.current.pause();
//       }
//     };

//     document.addEventListener("visibilitychange", handleVisibilityChange);
//     return () => {
//       document.removeEventListener("visibilitychange", handleVisibilityChange);
//     };
//   }, []);

//   if (!signData) return <LoadingIndicator />;

//   return (
//     <Box
//       sx={{ 
//         px: { xs: 1, sm: 6, md: 6 }, pt: 2, pb: 4 
//       }}
//     >
//       <Typography
//         variant="h4"
//         gutterBottom
//         align="center"
//         sx={{
//           fontSize: { xs: "1.5rem", sm: "1.7rem", md: "2rem" },
//         }}
//       >
//         {language === "en"
//           ? signData.enTitle.charAt(0).toUpperCase() + signData.enTitle.slice(1)
//           : signData.dzTitle
//           ? signData.dzTitle
//           : t(signData.enTitle) !== signData.enTitle
//           ? t(signData.enTitle)
//           : signData.enTitle.charAt(0).toUpperCase() +
//             signData.enTitle.slice(1)}
//       </Typography>

//       <Box
//         sx={{ flexDirection: "column" }}
//       >
//         <Box
//           component="img"
//           key={currentIndex}
//           src={signData.webpUrl}
//           alt={signData.enTitle}
//           sx={{
//             width: "100%",
//             height: { xs: 200, sm: 400, md: 500 },
//             mb: 0,
//             overflow: "hidden",
//             position: "relative",
//             objectFit: "contain",
//           }}
//         />

//         <Box
//           component="audio"
//           ref={audioRef}
//           src={signData.audioUrl}
//           controls
//           autoPlay
//           sx={{
//             width: { xs: 200, sm: 250, md: 350 },
//             height: { xs: 25, sm: 40 }, // Set a fixed height for the audio player
//             // mt: 1
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             mx: "auto", // Center horizontally
//             // mb:1,
//           }}
//         >
//           <VolumeDownIcon/>
//         </Box>

//         <Button
//             sx={{
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             mx: "auto",
//             }}
//         >
//           <VolumeDownIcon/>
//         </Button>

//         <Box
//           sx={{
//             display: "flex",
//             justifyContent: "space-around",
//             alignItems: "center",
//             mt: 1,
//             // px: 0, pb: 1
//           }}
//         >
//           <Button
//             onClick={() =>
//               navigate(
//                 `/home/signsCategory/${encodeURIComponent(
//                   category
//                 )}/${encodeURIComponent(
//                   categoryItemList[currentIndex - 1].enTitle
//                 )}`
//               )
//             }
//             disabled={currentIndex <= 0}
//             startIcon={<ArrowBackIosIcon />}
//             variant="outlined"
//           />

//           <Button
//             onClick={() =>
//               navigate(
//                 `/home/signsCategory/${encodeURIComponent(
//                   category
//                 )}/${encodeURIComponent(
//                   categoryItemList[currentIndex + 1].enTitle
//                 )}`
//               )
//             }
//             disabled={currentIndex >= categoryItemList.length - 1}
//             endIcon={<ArrowForwardIosIcon />}
//             variant="outlined"
//           />
//         </Box>
//       </Box>
//     </Box>
//   );
// }

// export default SignsSubScreenTwo;

